module.exports = __webpack_public_path__ + "media/images/icons/lock-9f913d4b227eb9be6c5d4c7ffea62e88.svg";